/* WhiteGold theme JS — dark mode, mobile menu, product gallery, countdown */
(function () {
  // Dark mode toggle
  var toggle = document.getElementById('wg-theme-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var html = document.documentElement;
      var dark = html.getAttribute('data-theme') === 'dark';
      if (dark) {
        html.removeAttribute('data-theme');
      } else {
        html.setAttribute('data-theme', 'dark');
      }
      try { localStorage.setItem('wg-theme', dark ? 'light' : 'dark'); } catch (e) {}
    });
  }

  // Language switcher — submit the localization form on change
  document.querySelectorAll('[data-locale-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  // Mobile menu
  var menu = document.getElementById('wg-mobilemenu');
  var open = document.getElementById('wg-menu-open');
  if (menu && open) {
    open.addEventListener('click', function () { menu.hidden = false; });
    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () { menu.hidden = true; });
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.hidden = true; });
    });
  }

  // Product gallery thumbnails
  var mainImage = document.getElementById('wg-main-image');
  if (mainImage) {
    document.querySelectorAll('.wg-product__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImage.src = btn.getAttribute('data-full');
      });
    });
  }

  // Variant price update
  var variantSelect = document.getElementById('wg-variant');
  var priceEl = document.getElementById('wg-price');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  }

  // Countdown to midnight (deal of the day)
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var h = cd.querySelector('[data-cd-h]');
    var m = cd.querySelector('[data-cd-m]');
    var s = cd.querySelector('[data-cd-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(diff / 3600));
      m.textContent = pad(Math.floor((diff % 3600) / 60));
      s.textContent = pad(diff % 60);
    };
    tick();
    setInterval(tick, 1000);
  }
})();
